<script lang="ts">
  import * as Icons from 'lucide-svelte';
  import Dropdown from '../components/dropdown/Dropdown.svelte';
  import type { DropdownPoints } from '../components/dropdown/dropdown.types';
  import { ModeService } from '../services/ModeService.svelte';

  const Mode = new ModeService();

  function useLightMode(): void {
    Mode.setMode('light');
  }

  function useDarkMode(): void {
    Mode.setMode('dark');
  }

  const SettingsPoints: DropdownPoints = $derived({
    p001: { label: 'Heller Modus', icon: Icons.Sun, active: Mode.isMode('light'), onselect: useLightMode },
    p002: { label: 'Dunkler Modus', icon: Icons.Moon, active: Mode.isMode('dark'), onselect: useDarkMode },
    p003: { label: 'Mein Konto', icon: Icons.CircleUser, separated: true, href: '/#User' },
    p004: { label: 'Einstellungen', icon: Icons.Settings, href: '/#Settings' },
    p005: { label: 'Abmelden', icon: Icons.LogOut, href: '/#Logout' },
  });
</script>

<aside class="LayoutSettings">
  <Dropdown icon="settings" label="Einstellungen öffnen" points={SettingsPoints} />
</aside>
